// src/pages/Likes.jsx
import React, { useState, useEffect, useContext } from 'react';
import { PlayerContext } from '../context/PlayerContext';
import { Heart, Play, Trash2, Music } from 'lucide-react';
import './Likes.css';

const Likes = () => {
  const [likedSongs, setLikedSongs] = useState([]);
  const { playSong, selectedSong } = useContext(PlayerContext) || {};

  useEffect(() => {
    try {
      const liked = JSON.parse(localStorage.getItem('aura_likes') || '[]');
      setLikedSongs(liked);
    } catch (_) {}
  }, []);

  const removeLike = (songId, e) => {
    e.stopPropagation();
    const updated = likedSongs.filter(s => s.id !== songId);
    setLikedSongs(updated);
    localStorage.setItem('aura_likes', JSON.stringify(updated));
  };

  const handlePlay = (song) => {
    if (playSong) playSong(song, likedSongs);
  };

  const playAll = () => {
    if (likedSongs.length > 0 && playSong) {
      playSong(likedSongs[0], likedSongs);
    }
  };

  const formatViews = (v) => {
    if (!v) return '';
    if (v >= 1e6) return `${(v / 1e6).toFixed(1)}M`;
    if (v >= 1e3) return `${(v / 1e3).toFixed(1)}K`;
    return v;
  };

  return (
    <div className="likes">
      {/* Header */}
      <div className="likes__header">
        <div className="likes__header-icon">
          <Heart size={32} fill="#ff7e3a" color="#ff7e3a" />
        </div>
        <div>
          <h1 className="likes__title">Liked Songs</h1>
          <p className="likes__count">{likedSongs.length} songs</p>
        </div>
        {likedSongs.length > 0 && (
          <button className="likes__play-all" onClick={playAll}>
            <Play size={16} fill="white" color="white" />
            Play All
          </button>
        )}
      </div>

      {/* List */}
      {likedSongs.length === 0 ? (
        <div className="likes__empty">
          <Music size={48} color="#e0e0e0" />
          <p>No liked songs yet</p>
          <span>Heart a song while it's playing to save it here</span>
        </div>
      ) : (
        <div className="likes__list">
          {likedSongs.map((song, idx) => (
            <div
              key={song.id}
              className={`likes__item${selectedSong?.id === song.id ? ' likes__item--active' : ''}`}
              onClick={() => handlePlay(song)}
            >
              <span className="likes__num">{idx + 1}</span>
              <img src={song.thumbnail} alt={song.title} className="likes__thumb" />
              <div className="likes__info">
                <p className="likes__song-title">{song.title}</p>
                <p className="likes__artist">{song.channelTitle}</p>
              </div>
              {song.viewCount && (
                <span className="likes__views">{formatViews(song.viewCount)} views</span>
              )}
              <div className="likes__actions">
                <button
                  className="likes__remove"
                  onClick={(e) => removeLike(song.id, e)}
                  title="Remove"
                >
                  <Trash2 size={15} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Export a helper to like a song from anywhere
export const toggleLike = (song) => {
  try {
    const liked = JSON.parse(localStorage.getItem('aura_likes') || '[]');
    const exists = liked.find(s => s.id === song.id);
    let updated;
    if (exists) {
      updated = liked.filter(s => s.id !== song.id);
    } else {
      updated = [song, ...liked];
    }
    localStorage.setItem('aura_likes', JSON.stringify(updated));
    return !exists; // returns new liked state
  } catch (_) { return false; }
};

export const isLiked = (songId) => {
  try {
    const liked = JSON.parse(localStorage.getItem('aura_likes') || '[]');
    return liked.some(s => s.id === songId);
  } catch (_) { return false; }
};

export default Likes;